import React from 'react';
import styles from './StatusCardMiniView.module.scss';

export interface StatusCardMiniViewProps {
  isOnline: boolean;
  deviceId?: string;
  lastSeen?: string;
  statusText?: string;
  showLastSeen?: boolean;
  formattedDate?: string | null;
}

export default function StatusCardMiniView({
  isOnline,
  deviceId,
  lastSeen,
  statusText,
  showLastSeen = false,
  formattedDate
}: StatusCardMiniViewProps) {
  const getStatusInfo = () => {
    if (isOnline) {
      return {
        text: 'En ligne',
        className: styles.statusOnline,
        icon: '🟢',
        pulse: true
      };
    } else {
      return {
        text: 'Hors ligne',
        className: styles.statusOffline,
        icon: '⚫',
        pulse: false
      };
    }
  };

  const statusInfo = getStatusInfo();
  
  // Construire le tooltip avec les informations disponibles
  const tooltipText = [
    deviceId && `ID: ${deviceId}`,
    statusText && `Statut: ${statusText}`,
    formattedDate && `Dernière activité: ${formattedDate}`,
    lastSeen && showLastSeen && `Vu: ${lastSeen}`
  ].filter(Boolean).join('\n');

  return (
    <div className={styles.statusCardMini} title={tooltipText || undefined}>
      <div className={[styles.statusIndicator, statusInfo.className].join(' ')}>
        <div className={styles.statusIcon}>
          <span className={[styles.iconEmoji, !isOnline && styles.iconEmojiOffline].join(' ')}>
            {statusInfo.icon}
          </span>
          {statusInfo.pulse && <div className={styles.pulseRing}></div>}
        </div>
        
        <div className={styles.statusText}>
          <span className={[styles.statusLabel, isOnline ? styles.statusLabelOnline : styles.statusLabelOffline].join(' ')}>
            {statusInfo.text}
          </span>
        </div>
      </div>
    </div>
  );
}

